export default __webpack_public_path__ + "static/media/tavi_mobile_small.a6d7ec94.jpg";